import { Directive, ElementRef, Output, EventEmitter, HostListener, Input, NgZone } from '@angular/core';

@Directive({
    selector: '[closeOverlay]',
    standalone: false
})
export class CloseOverlayDirective { // for closing overlay in UI Engine search.
    constructor(private _elementRef: ElementRef, private ngZone: NgZone) {
    }

    @Output()
    public closeOverlay = new EventEmitter<MouseEvent>();
    @HostListener('document:click', ['$event', '$event.target'])
    public onClick(event: MouseEvent, targetElement: HTMLElement): void {
        this.ngZone.runOutsideAngular(() => {
            if (!targetElement) {
                return;
            }
            if (targetElement.className.indexOf('cstmOverlay') > -1) {
                this.closeOverlay.emit(event);
            }
        })
    }
}
